// Feature switches (platform console) and the new-store setup guide.
export default {
  "Point-of-sale screen for counter sales": "شاشة نقطة البيع للمبيعات على الكاونتر",
  "Kitchen display for incoming orders": "شاشة المطبخ للطلبات الواردة",
  "Tables and QR codes for dine-in ordering": "الطاولات ورموز QR للطلب داخل المطعم",
  "Table reservations": "حجوزات الطاولات",
  "Opening hours and closed days": "ساعات العمل وأيام الإغلاق",
  "Stock levels and low-stock alerts": "مستويات المخزون وتنبيهات انخفاضه",
  "Staff accounts and PINs": "حسابات الموظفين ورموز PIN",
  "Customer list and loyalty points": "قائمة العملاء ونقاط الولاء",
  "WhatsApp marketing campaigns": "حملات التسويق عبر واتساب",
  "Sales reports": "تقارير المبيعات",
  "Storefront themes and design": "قوالب المتجر وتصميمه",
  "Choose what this business sees in its admin panel. Hidden sections disappear from its menu and stop working.": "اختر ما يراه هذا النشاط في لوحة الإدارة. الأقسام المخفية تختفي من القائمة وتتوقف عن العمل.",
  "{v0} hidden for this business": "تم إخفاء {v0} لهذا النشاط",
  "{v0} turned on for this business": "تم تفعيل {v0} لهذا النشاط",
  "This feature is not available for your business": "هذه الميزة غير متاحة لنشاطك التجاري",
  "Set up your restaurant": "جهّز مطعمك",
  "Set up your online store": "جهّز متجرك الإلكتروني",
  "Set up your booking page": "جهّز صفحة الحجز",
  "{done} of {total} steps done": "تم إنجاز {done} من {total} خطوات",
  "Hide the setup guide": "إخفاء دليل الإعداد",
  "You're all set!": "كل شيء جاهز!",
  "Your business is ready for customers.": "نشاطك التجاري جاهز لاستقبال العملاء.",
  "Add your logo": "أضف شعارك",
  "It shows on your website, receipts and QR codes.": "يظهر على موقعك والإيصالات ورموز QR.",
  "Create your first category": "أنشئ أول فئة",
  "Group your products, e.g. Clothes, Shoes, Accessories.": "نظّم منتجاتك، مثل: ملابس، أحذية، إكسسوارات.",
  "Add category": "إضافة فئة",
  "Create your first menu category": "أنشئ أول فئة في القائمة",
  "Group your dishes, e.g. Starters, Mains, Drinks.": "نظّم أطباقك، مثل: مقبلات، أطباق رئيسية، مشروبات.",
  "Add your first product": "أضف أول منتج",
  "Give it a name, a price, photos and stock.": "أعطه اسمًا وسعرًا وصورًا وكمية في المخزون.",
  "Add product": "إضافة منتج",
  "Add your first dish": "أضف أول طبق",
  "Give it a name, a price and a photo.": "أعطه اسمًا وسعرًا وصورة.",
  "Add dish": "إضافة طبق",
  "Add your tables": "أضف طاولاتك",
  "Each table gets a QR code customers scan to order.": "لكل طاولة رمز QR يمسحه العملاء للطلب.",
  "Add tables": "إضافة طاولات",
  "Choose how customers pay": "اختر طرق الدفع لعملائك",
  "Cash, card with Stripe, or bank transfer.": "نقدًا، أو بالبطاقة عبر Stripe، أو بتحويل بنكي.",
  "Set up payments": "إعداد الدفع",
  "Add your first service": "أضف أول خدمة",
  "Its name, price and how long it takes.": "اسمها وسعرها ومدتها.",
  "Add service": "إضافة خدمة",
  "Set your opening hours": "حدّد ساعات العمل",
  "Customers can only book when you are open.": "لا يمكن للعملاء الحجز إلا خلال ساعات عملك.",
  "Set hours": "تحديد الساعات",
  "Share your booking page": "شارك صفحة الحجز",
  "Open your page, try a booking, then send the link to your customers.": "افتح صفحتك، وجرّب حجزًا، ثم أرسل الرابط لعملائك.",
  "Share your website and get your first order": "شارك موقعك واحصل على أول طلب",
  "Open your website, try an order, then send the link to your customers.": "افتح موقعك، وجرّب طلبًا، ثم أرسل الرابط لعملائك.",
};
